export default __webpack_public_path__ + "static/media/header-link-logo.5f1830aa.png";